// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../../../../../../../../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../../../../../../../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.container-configuration-list-item {
  display: grid;
  grid-template-columns: 0.2fr 1fr;
  column-gap: 20px;
  max-width: 675px;
  width: 100%;
  border: 1px solid #b9bfc5;
  margin: 20px 0;
}

  .container-configuration-list-item__configs {
    display: flex;
    flex-direction: column;
    align-items: flex-start;
    border-left: 1px solid #b9bfc5;
  }

  .container-configuration-list-item__container-number {
    display: flex;
    align-items: center;
    font-size: 14px;
    font-weight: 400;
    line-height: 15px;
    letter-spacing: 0.0025em;
    text-align: left;
    margin: auto;
    max-width: 197px;;
    width: 100%;
    padding: 35px;
  }

  .container-configuration-list-item__container-number > button {
      display: block;
      width: 25px;
      height: 25px;
      cursor: pointer;
    }

  .container-configuration-list-item__event-ingate {
    border-bottom: 1px solid #b9bfc5;
  }

  .container-configuration-list-item__event-outgate,
  .container-configuration-list-item__event-ingate {
    display: grid;
    grid-template-columns: 0.6fr 1fr 0.6fr;
    justify-content: baseline;
    padding: 5px 10px;
    width: 100%;
  }

  .container-configuration-list-item__event-outgate > div, .container-configuration-list-item__event-ingate > div {
      margin: 0 auto;
      padding: 10px;
      width: 100%;
      justify-content: flex-start;
    }

  .container-configuration-list-item__container-text {
    width: 80%;
    overflow-wrap: break-word;
  }
`, "",{"version":3,"sources":["webpack://./app/_blessed/components/features/Admin/features/Scraper/features/AppointmentBooking/components/SubscribeToContainers/Components/ContainerConfigurationsListItems/styles.css"],"names":[],"mappings":"AAAA;EACE,aAAa;EACb,gCAAgC;EAChC,gBAAgB;EAChB,gBAAgB;EAChB,WAAW;EACX,yBAAyB;EACzB,cAAc;AAsDhB;;EApDE;IACE,aAAa;IACb,sBAAsB;IACtB,uBAAuB;IACvB,8BAA8B;EAChC;;EAEA;IACE,aAAa;IACb,mBAAmB;IACnB,eAAe;IACf,gBAAgB;IAChB,iBAAiB;IACjB,wBAAwB;IACxB,gBAAgB;IAChB,YAAY;IACZ,gBAAgB;IAChB,WAAW;IACX,aAAa;EAQf;;EANE;MACE,cAAc;MACd,WAAW;MACX,YAAY;MACZ,eAAe;IACjB;;EAGF;IACE,gCAAgC;EAClC;;EAEA;;IAEE,aAAa;IACb,sCAAsC;IACtC,yBAAyB;IACzB,iBAAiB;IACjB,WAAW;EAQb;;EANE;MACE,cAAc;MACd,aAAa;MACb,WAAW;MACX,2BAA2B;IAC7B;;EAGF;IACE,UAAU;IACV,yBAAyB;EAC3B","sourcesContent":[".container-configuration-list-item {\n  display: grid;\n  grid-template-columns: 0.2fr 1fr;\n  column-gap: 20px;\n  max-width: 675px;\n  width: 100%;\n  border: 1px solid #b9bfc5;\n  margin: 20px 0;\n\n  &__configs {\n    display: flex;\n    flex-direction: column;\n    align-items: flex-start;\n    border-left: 1px solid #b9bfc5;\n  }\n\n  &__container-number {\n    display: flex;\n    align-items: center;\n    font-size: 14px;\n    font-weight: 400;\n    line-height: 15px;\n    letter-spacing: 0.0025em;\n    text-align: left;\n    margin: auto;\n    max-width: 197px;;\n    width: 100%;\n    padding: 35px;\n\n    & > button {\n      display: block;\n      width: 25px;\n      height: 25px;\n      cursor: pointer;\n    }\n  }\n\n  &__event-ingate {\n    border-bottom: 1px solid #b9bfc5;\n  }\n\n  &__event-outgate,\n  &__event-ingate {\n    display: grid;\n    grid-template-columns: 0.6fr 1fr 0.6fr;\n    justify-content: baseline;\n    padding: 5px 10px;\n    width: 100%;\n\n    > div {\n      margin: 0 auto;\n      padding: 10px;\n      width: 100%;\n      justify-content: flex-start;\n    }\n  }\n\n  &__container-text {\n    width: 80%;\n    overflow-wrap: break-word;\n  }\n}\n"],"sourceRoot":""}]);
// Exports
export default ___CSS_LOADER_EXPORT___;
